import { Helmet } from 'react-helmet-async';
import { TopBar } from './TopBar';
import { BottomBar } from './BottomBar';
import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
  title: string;
  showBack?: boolean;
  skipHelmet?: boolean;
}

export function Layout({ children, title, showBack = true, skipHelmet = false }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      {!skipHelmet && (
        <Helmet>
          <title>{title} | JEM PWA</title>
        </Helmet>
      )}
      <TopBar title={title} showBack={showBack} />

      {/* Main content avec padding pour la navigation */}
      <main className="lg:ml-64 pb-20 lg:pb-4">
        <div className="container mx-auto px-4 py-6 max-w-7xl animate-page">
          {children}
        </div>
      </main>

      <BottomBar />
    </div>
  );
}
